'use strict'

define [], () ->
  ($rootScope, $scope, $http, RENTAPPLICATION_API_URL, $uibModalInstance) ->
    $scope.is_loading = false
    $scope.custom_message = ""
    $scope.recipients = [{
      name: "",
      email: ""
    }]
    $scope.error_message = ""

    $scope.remove_recipient = (index) ->
      if index == 0
        return
      $scope.recipients.splice(index, 1)

    $scope.add_recipient = () ->
      $scope.recipients.push({
        name: "",
        email: ""
      })

    $scope.send_invite = () ->
      if $scope.recipients.some((r) -> !r.email or !r.name)
        return
        
      $scope.is_loading = true

      data = {
        custom_message: $scope.custom_message,
        recipients: $scope.recipients,
      }
      
      $http.post("#{RENTAPPLICATION_API_URL}/api/v3/referrers/send_invitation/", data)
        .then (resp) ->
          $uibModalInstance.close(true)
        .catch (err) ->
          $scope.error_message = err.data.message
        .finally ->
          $scope.is_loading = false


// WEBPACK FOOTER //
// ./components/dashboard/referral/modals/invite.coffee